import React from 'react';
import {
  StoreSiteType,
  StoreSiteSection,
  StoreHookupType,
} from '../../types/site';
import { SiteFilters as SiteFiltersType, SiteListStatus } from '../../types/siteData';

interface SiteFiltersProps {
  filters: Partial<SiteFiltersType>;
  onFiltersChange: (filters: Partial<SiteFiltersType>) => void;
  siteTypes: StoreSiteType[];
  sections: StoreSiteSection[];
  hookupTypes: StoreHookupType[];
}

const STATUS_OPTIONS: { value: SiteListStatus; label: string }[] = [
  { value: 'available', label: 'Available' },
  { value: 'seasonal', label: 'Seasonal' },
  { value: 'blocked', label: 'Blocked' },
];

const SiteFilters: React.FC<SiteFiltersProps> = ({
  filters,
  onFiltersChange,
  siteTypes,
  sections,
  hookupTypes,
}) => {
  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onFiltersChange({ ...filters, search: e.target.value || undefined });
  };

  const handleTypeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const value = e.target.value;
    onFiltersChange({ ...filters, type_id: value ? parseInt(value) : undefined });
  };

  const handleSectionChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const value = e.target.value;
    onFiltersChange({ ...filters, section_id: value ? parseInt(value) : undefined });
  };

  const handleStatusChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const value = e.target.value;
    onFiltersChange({ ...filters, status: value ? (value as SiteListStatus) : undefined });
  };

  const clearFilters = () => {
    onFiltersChange({});
  };

  const hasActiveFilters = Object.values(filters).some(v => v !== undefined);

  return (
    <div className="site-filters">
      <div className="filters-row">
        <div className="filter-group search-group">
          <input
            type="text"
            placeholder="Search by alias or description..."
            value={filters.search || ''}
            onChange={handleSearchChange}
            className="filter-input search-input"
          />
        </div>

        <div className="filter-group">
          <select
            value={filters.type_id || ''}
            onChange={handleTypeChange}
            className="filter-select"
          >
            <option value="">All Type Names</option>
            {siteTypes.map((type) => (
              <option key={type.id} value={type.id}>
                {type.name}
              </option>
            ))}
          </select>
        </div>

        <div className="filter-group">
          <select
            value={filters.section_id || ''}
            onChange={handleSectionChange}
            className="filter-select"
          >
            <option value="">All Sections</option>
            {sections.map((section) => (
              <option key={section.id} value={section.id}>
                {section.name}
              </option>
            ))}
          </select>
        </div>

        <div className="filter-group">
          <select
            value={filters.status || ''}
            onChange={handleStatusChange}
            className="filter-select"
          >
            <option value="">All Statuses</option>
            {STATUS_OPTIONS.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>

        {hasActiveFilters && (
          <button className="clear-filters-btn" onClick={clearFilters}>
            Clear All
          </button>
        )}
      </div>

    </div>
  );
};

export default SiteFilters;
